import ProjectStatus from "@/components/Projects/ProjectStatus.vue";


export default [{
    path: 'project',
    alias: 'projects',
    name: 'Projects',
    redirect: "/project/status",
    meta: {
        requiresAuth: true
    },
    children: [
        {
            path: "status",
            name: "Project Status",
            components: {
                page: ProjectStatus
                /* modal: JobEdit, */
            }
        }
    ]
}];